import React$1 from 'react';
import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Icon$1 from '../Icon/Icon.js';
import StyledLink from './Link.style.js';

const Link = (_ref) => {
  let {
    asPath,
    children,
    component,
    href,
    icon,
    transform,
    type,
    variant,
    noHover
  } = _ref,
      props = _objectWithoutProperties(_ref, ["asPath", "children", "component", "href", "icon", "transform", "type", "variant", "noHover"]);

  return /*#__PURE__*/React$1.createElement(StyledLink, _extends({
    asPath: asPath,
    component: component,
    href: href,
    icon: icon,
    transform: transform,
    type: type,
    variant: variant,
    noHover: noHover
  }, props), children, icon && /*#__PURE__*/React$1.createElement(Icon$1, {
    icon: icon
  }));
};

Link.propTypes = {
  asPath: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.shape()]),
  children: PropTypes$1.node,
  component: PropTypes$1.oneOfType([PropTypes$1.node, PropTypes$1.element, PropTypes$1.string]),
  href: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.shape()]),
  icon: PropTypes$1.string,
  transform: PropTypes$1.oneOf(['uppercase', 'lowercase', 'none']),
  type: PropTypes$1.string,
  variant: PropTypes$1.string,
  noHover: PropTypes$1.bool
};
Link.defaultProps = {
  asPath: '',
  component: null,
  children: null,
  href: '',
  icon: null,
  transform: 'none',
  type: null,
  variant: 'copy',
  noHover: false
};

export default Link;
